import React from 'react';
import '../Contact/Contact-post.css';

const ContactPost = () => {
  return (
    <section className="contact-post">
      <div className="contact-background"></div>
      <div className="contact-content">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-text">Get Intouch</p>
      </div>
    </section>
  );
};

export default ContactPost;